import { Injectable, inject, type ErrorHandler } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable()
export class AppInsightsErrorHandler implements ErrorHandler {
  private readonly appInsights = inject(AppInsightsService);

  handleError(error: Error): void {
    // Always log to console for development
    console.error('Application error:', error);

    // Track in Application Insights if available
    try {
      this.appInsights.trackException(error, 3); // Severity: Error
    } catch (appInsightsError) {
      // If AppInsights fails, just log it - don't let it break error handling
      console.error('Failed to send error to Application Insights:', appInsightsError);
    }

    // Re-throw to ensure Angular's default error handling still occurs
    // Comment this out if you want to suppress errors completely
    throw error;
  }
}
